const en = {
  title: 'Settings',
  selectTitle: 'Select title',
  usernameTxt: 'Username',
  email: 'Email',
  visible: 'Visible to:',
  everyone: 'Everyone',
  onlyYou: 'Only you',
  linkedIn: 'LinkedIn profile',
  saveBtn: 'Save',
  cancelBtn: 'Cancel',
  usernameValidationMessage:
    'Must be 4-30 characters. No special characters allowed.',
  invalidLinkedIn: 'Please enter a valid LinkedIn URL.',
};

export default en;
